<template>
  <div v-loading="loading">
    <div>
      <div class="desc-item">
        <span class="field-title">Javob:</span>
        <span>{{ question.answer }}</span>
      </div>
      <div class="desc-item">
        <span class="field-title">Javob beruvchi:</span>
        <span>Admin</span>
      </div>
      <div class="desc-item">
        <span class="field-title">Javob berilgan sana:</span>
        <span>{{ $moment(question.created_date).format("lll") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerItem",
  props: {
    question: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.desc-item {
  margin: 10px;
}

.field-title {
  color: #0f152d;
  font-weight: bold;
  margin-right: 5px;
}
</style>
